import React from "react";
import { FormattedMessage } from "react-intl";

// mui
import Typography from "@mui/material/Typography";

// image
import defaultImg from "../../../../../../../../../../images/ocr_image/ocr_file_default.png";

const styles = { fontSize: "14px", color: "#6D6D6D" };
const DefaultContent = () => (
  <>
    <img src={defaultImg} alt="default" width={200} height={200} />
    <Typography sx={styles}>
      <FormattedMessage
        id="sna.sidetool.digitalAITool.ocr.uploading.limit1"
        defaultMessage="File import size limit is 10MB per upload."
      />
    </Typography>
    <Typography sx={styles}>
      <FormattedMessage
        id="sna.sidetool.digitalAITool.ocr.uploading.limit2"
        defaultMessage="Supported formats include PNG, JPG, WEBP, and PDF."
      />
    </Typography>
    <Typography sx={styles}>
      <FormattedMessage
        id="sna.sidetool.digitalAITool.ocr.uploading.limit3"
        defaultMessage="The file name cannot contain the following characters: { } `"
      />
    </Typography>
    <Typography sx={styles}>
      <FormattedMessage
        id="sna.sidetool.digitalAITool.ocr.uploading.limit4"
        defaultMessage="It is recommended that text in imported files be in printed fonts for better recognition results."
      />
    </Typography>
  </>
);
export default DefaultContent;
